import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-list\">\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\n<g><path d=\"M10,82.3h132.7v132.2H10V82.3z M279.5,82.3H990v132.2H279.5V82.3L279.5,82.3z M10,445.5h132.7v132.2H10V445.5z M279.5,445.5H990v132.2H279.5V445.5L279.5,445.5z M10,785.7h132.7v131.9H10V785.7z M279.5,785.7H990v131.9H279.5V785.7L279.5,785.7z\" /></g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol